import Vue from 'vue'

import rowCellContent from './not-set-row-cell-content'
Vue.component(rowCellContent.name, rowCellContent)

export default {
    slots() {
        return [
            {
                slot: "row-cell-content",
                component: rowCellContent.name,
                condition(attrs) {
                    return this.emptyText !== false && ( inArray(attrs.content, this.emptyTextOnEmptyValues, true) || (this.emptyTextOnEmptyString && attrs.content === ""))
                }
            }
        ]
    },
    mixins() {
        return {
            props: {
                emptyText: {
                    type: [String, Boolean],
                    default: '(not set)'
                },
                emptyTextOnEmptyString: {
                    type: Boolean,
                    default: true
                },
                emptyTextTag: {
                    default: 'span'
                },
                emptyTextOnEmptyValues: {
                    type: Array,
                    default: () => [null, undefined]
                },
                emptyTextOptions: {
                    type: Object,
                    default: () => ({
                        class: ['empty', 'text-muted']
                    })
                }
            }
        }
    }
}
